module.exports = __webpack_public_path__ + "img/ico_error.8673ef08.svg";